// Application Version
// Update this version number with each deployment
export const APP_VERSION = "2.9.0";
